const nameList = [
    'Aarav', 'Vivaan', 'Aditya', 'Vihaan', 'Arjun',
    'Sai', 'Reyansh', 'Ayaan', 'Krishna', 'Ishaan',
    'Shaurya', 'Atharv', 'Advik', 'Pranav', 'Advaith',
    'Aarush', 'Kabir', 'Ritvik', 'Ananya', 'Diya',
    'Saanvi', 'Aanya', 'Aadhya', 'Isha', 'Anvi',
    'Priya', 'Meera', 'Kavya', 'Navya', 'Aisha',
    'Rohan', 'Vikram', 'Amit', 'Rahul', 'Deepak',
    'Suresh', 'Rajesh', 'Pooja', 'Neha', 'Shreya',
    'Tanvi', 'Riya', 'Simran', 'Nisha', 'Divya',
    'Karan', 'Nikhil', 'Mohit', 'Gaurav', 'Harsh',
    'Manish', 'Sachin', 'Yash', 'Dev', 'Raj',
    'Lakshmi', 'Suman', 'Geeta', 'Rekha', 'Anjali',
    'Varun', 'Akash', 'Kunal', 'Siddharth', 'Ankur',
    'Bhavna', 'Swati', 'Jyoti', 'Pallavi', 'Sneha',
    'Aman', 'Tushar', 'Vishal', 'Abhishek', 'Tarun',
    'Nandini', 'Madhuri', 'Komal', 'Ritika', 'Sonali'
];

const liveChatMessages = [
    "Hey, nice video!",
    "Thanks for sharing this.",
    "Really interesting topic.",
    "I learned something new today.",
    "Great explanation, very clear.",
    "Can you make a follow-up on this?",
    "I had the same question, glad you covered it.",
    "This is so well made.",
    "Watching from Mumbai!",
    "The editing is really good.",
    "How long did this take to make?",
    "Subscribed, looking forward to more.",
    "This helped me a lot, thank you.",
    "I've been looking for this kind of content.",
    "Good point, never thought about it that way.",
    "Anyone else here from the recommended page?",
    "Keep up the good work!",
    "This deserves more views.",
    "Could you share the resources you mentioned?",
    "Watching this during lunch break.",
    "Love the background music choice.",
    "Very well explained.",
    "That makes so much sense now.",
    "Saved this for later.",
    "What camera do you use?",
    "The audio quality is really nice.",
    "Been following this channel for a while now.",
    "Please do more videos like this.",
    "This is exactly what I needed.",
    "How do you know so much about this?",
    "Just shared this with my friends.",
    "Commenting so the algorithm picks this up.",
    "Quality content right here.",
    "Waiting for the next one.",
    "Nice thumbnail by the way.",
    "Short and to the point, I like it.",
    "Can you do a tutorial on this?",
    "Solid video as always.",
    "Watching from Delhi.",
    "Where can I read more about this?",
    "Thanks, this cleared up my doubts.",
    "Your channel is underrated.",
    "Good evening everyone.",
    "Just discovered this channel today.",
    "That was a really smooth transition.",
    "Interesting perspective.",
    "I appreciate the effort you put into these.",
    "Looking forward to the next upload.",
    "This was very helpful.",
    "Well done, keep it up!"
];

export const getRandomSentence = () => {
    return liveChatMessages[Math.floor(Math.random() * liveChatMessages.length)];
};

export const getRandomName = () => {
    return nameList[Math.floor(Math.random() * nameList.length)];
};

export const generateId = () => {
    return crypto.randomUUID();
};

export const formatTimeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const intervals = {
        year: 31536000,
        month: 2592000,
        week: 604800,
        day: 86400,
        hour: 3600,
        minute: 60,
        second: 1
    };

    for (const [unit, secondsInUnit] of Object.entries(intervals)) {
        const interval = Math.floor(seconds / secondsInUnit);
        if (interval >= 1) {
            return interval === 1 ? `${interval} ${unit} ago` : `${interval} ${unit}s ago`;
        }
    }
    return 'just now';
};

export const formatViews = (count) => {
    const num = Number(count);
    if (isNaN(num)) return count;
    if (num >= 1000000) {
        return `${(num / 1000000).toFixed(1)}M`;
    }
    if (num >= 1000) {
        return `${(num / 1000).toFixed(1)}K`;
    }
    return String(num);
};

export const formatDuration = (duration) => {
    const match = duration?.match(/PT(\d+H)?(\d+M)?(\d+S)?/);
    if (!match) return '0:00';
    const hours = (match[1] || '').replace('H', '');
    const minutes = (match[2] || '').replace('M', '');
    const seconds = (match[3] || '').replace('S', '');

    if (hours) {
        return `${hours}:${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
    }
    return `${minutes || '0'}:${seconds.padStart(2, '0')}`;
};